import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    footerMenu: {
      position: 'fixed',
      bottom: 0,
      left: 50,
      width: 950,
      [theme.breakpoints.down('md')]: {
        width: '88%',
      },
      [theme.breakpoints.down('sm')]: {
        left: 0,
        width: '100%',
      },
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    tableButton: {
      right: 10,
      bottom: 35,
      position: 'absolute',
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.short,
      }),
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    tableOpen: {
      transform: 'rotate(180deg)',
      [theme.breakpoints.down('sm')]: {
        transform: 'rotate(0deg)',
      },
    },
    tableClosed: {
      transform: 'rotate(0)',
      [theme.breakpoints.down('sm')]: {},
    },
    tableText: {
      fontSize: '16px',
      alignSelf: 'center',
      fontWeight: 'normal',
      marginLeft: '2%',
    },
    tableButonIcon: {
      height: 30,
      width: 30,
      [theme.breakpoints.down('sm')]: {
        transform: 'rotate(180deg)',
        marginRight: '2%',
      },
    },
    tableDrawer: {
      top: 'auto',
      height: 460,
      width: 250,
      marginRight: 75,
      bottom: 45,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    tableDrawerResp: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        top: 'auto',
        height: 460,
        width: 250,
        bottom: 45,
        marginRight: 20,
      },
    },
    accidentCard: {
      willChange: 'auto !important',
      margin: 10,
      fontWeight: 'bold',
    },
    accidentLabel: {
      width: '100%',
      padding: 10,
      borderTopLeftRadius: '2px',
      borderTopRightRadius: '2px',
      backgroundColor: Colors.secundary,
      fontFamily: 'Texta Medium',
      letterSpacing: '1px',
      color: Colors.tertiary,
      textAlign: 'center',
    },
    accidentValue: {
      padding: 5,
      textAlign: 'center',
      color: Colors.black,
    },
    chartsMenu: {
      width: '100%',
      height: 440,
      [theme.breakpoints.down('sm')]: {
        marginLeft: '0%',
        width: '100%',
        backgroundColor: 'white',
      },
    },
    exportPalette: {
      width: '205px',
      position: 'relative',
      left: '375px',
      border: '1px solid #ccc',
      [theme.breakpoints.down('sm')]: {
        left: 0,
        width: '100%',
        position: 'static',
      },
    },
    cancel: {
      display: 'none',
      fontWeight: 'bold',
      color: '#B44949',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
    },
    buttonPalette: {
      width: '100%',
      height: '49px',
      backgroundColor: 'white',
      textTransform: 'capitalize',
      borderRadius: '0px',
    },
    button: {
      width: 50,
      height: 50,
      paddingLeft: 10,
      paddingRight: 10,
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: '#d2d2d2',
      },
      [theme.breakpoints.down('sm')]: {
        height: 0,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: 'none',
      },
    },
    responsiveButton: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexFlow: 'column',
        margin: '2% 0 2% 0',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    pageNameChip: {
      marginBottom: 15,
      fontFamily: 'Texta Medium',
      letterSpacing: '1px',
      fontSize: 16,
      paddingLeft: 15,
      paddingRight: 15,
      backgroundColor: Colors.main,
      color: Colors.tertiary,
    },
    topPageNameChip: {
      position: 'absolute',
      zIndex: 5,
      left: 60,
      top: 173,
      boxShadow: theme.shadows[1],
      [theme.breakpoints.down('sm')]: {
        display: "none"
      }
    },
    btnSelected: {
      backgroundColor: Colors.secundary,
      fontWeight: 'bold',
      color: '#404040',
    },
    responsivemenuButton: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        boxShadow: theme.shadows[5],
        padding: 10,
        fontFamily: 'Roboto',
        marginBottom: '2%',
      },
    },
    responsiveButtonMap: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        boxShadow: theme.shadows[5],
        padding: 10,
        backgroundColor: Colors.secundary,
        color: '#404040',
        fontWeight: 'bolder',
        fontFamily: 'Roboto',
        marginBottom: '2%',
      },
    },
    menuButton: {
      marginRight: 20,
      textTransform: 'none',
      height: 40,
      fontSize: 16,
      marginTop: 0,
      marginBottom: 0,
      boxShadow: theme.shadows[5],
      padding: 10,
      backgroundColor: 'white',
      fontFamily: 'Roboto',
      textDecoration: "none",
      borderRadius: 0,
      fontWeight: 'normal',
      "&:hover": {
        backgroundColor: '#e4e0e0',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    footerMenuActive: {
      backgroundColor: Colors.secundary,
      color: '#404040',
    },
    loadingContainer: {
      display: 'flex',
      marginTop: '30px',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.secundary,
    },
    buttonClose: {
      position: 'relative',
      top: 0,
      height: 40,
      width: 40,
      margin: 5,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    buttonCloseResponsive: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        width: '100%',
        backgroundColor: Colors.secundary,
        color: '#404040',
        fontWeight: 'bolder',
        zIndex: 160,
      },
    },
  }),
);
